import { Button, Link, Stack, Typography } from '@mui/material';

import { links } from '@/localization';

import { TrainingAnimationContainer } from '../../Overview/styled';
import EmptyStateContainer from '../../sections/EmptyStateContainer';

function EmptyState() {
  return (
    <EmptyStateContainer>
      <Stack alignItems="center" maxWidth={500} gap={4}>
        <TrainingAnimationContainer />
        <Stack gap={2}>
          <Typography variant="h3" textAlign="center">
            You haven&apos;t created any training projects yet
          </Typography>
          <Typography textAlign="center" color="text.secondary">
            Run reproducible, scalable training jobs with full control over data, code, compute, and
            runtime settings.{' '}
            <Link href={links.basetenDocsTrainingOverview} target="_blank">
              Learn more
            </Link>
          </Typography>
        </Stack>
        <Button href={links.basetenDocsTrainingOverview} target="_blank">
          Train or fine-tune a model
        </Button>
      </Stack>
    </EmptyStateContainer>
  );
}

export { EmptyState };
